import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Parameter } from '../components/create-custom-kpi/types'

interface Stage {
  parameter1: Parameter
  parameter2: Parameter
  arithmeticIndicator: { value: string, label: string }
  calculatedName: string
}

const initialState = {
  kpiName: '',
  remarks: '',
  operator: '',
  totalizer: false,
  trueCondition: true,
  stages: new Array(4).fill({
    parameter1: { assetId: '', asset: '', deviceId: '', device: '', parameterId: '', parameter: '', parameterType: '', constantValue: '' },
    parameter2: { assetId: '', asset: '', deviceId: '', device: '', parameterId: '', parameter: '', parameterType: '', constantValue: '' },
    arithmeticIndicator: { value: '', label: '' },
    operator: '',
    operatorType: '',
    calculatedName: ''
  }),
  higherLimitNotification: '',
  lowerLimitNotification: '',
  scaleFactor: '',
  totalizerType: '',
  totalizePeriod: ''
}

const CustomKpiSlice = createSlice({
  name: 'customKpi',
  initialState,
  reducers: {
    setKpiName: (state, action: PayloadAction<string>) => {
      state.kpiName = action.payload
    },
    setRemarks: (state, action: PayloadAction<string>) => {
      state.remarks = action.payload
    },
    setTotalizer: (state, action: PayloadAction<boolean>) => {
      state.totalizer = action.payload
    },
    setTrueCondition: (state, action: PayloadAction<boolean>) => {
      state.trueCondition = action.payload
    },
    setScaleFactor: (state, action: PayloadAction<string>) => {
      state.scaleFactor = action.payload
    },
    setTotalizerType: (state, action: PayloadAction<string>) => {
      state.totalizerType = action.payload
    },
    setTotalizePeriod: (state, action: PayloadAction<string>) => {
      state.totalizePeriod = action.payload
    },
    setOperator: (state, action: PayloadAction<string>) => {
      state.operator = action.payload
    },
    setStages: (state, action: PayloadAction<Stage[]>) => {
      state.stages = action.payload
    },
    setHigherLimitNotification: (state, action: PayloadAction<string>) => {
      state.higherLimitNotification = action.payload
    },
    setLowerLimitNotification: (state, action: PayloadAction<string>) => {
      state.lowerLimitNotification = action.payload
    },
    reset: () => initialState
  }
})

export const {
  setKpiName, setRemarks, setOperator, setStages, setHigherLimitNotification, setLowerLimitNotification, reset, setTotalizer, setTrueCondition, setScaleFactor, setTotalizerType, setTotalizePeriod
} = CustomKpiSlice.actions

export default CustomKpiSlice.reducer
